import axios from "axios";
import { Config } from "../../../core/config/config";
import { getTimeByGMT } from "@/core/helper/date-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/replenishment/account_parameter`;
const ENDPOINTS = {
    gmt: `${GATEWAY_URL}/gmt`,
};



export const accountParameterService = {
    async getGmt() {
        try {
            const response = await axios.get(ENDPOINTS.gmt);
            return response.data.gmtValue;
        } catch (error) {
            console.error("Failed to fetch GMT value", error);
            throw error;
        }
    },

    isPastCutoffTime(cutoffTime: string | null | undefined, accountGmtValue: number): boolean {
        if (!cutoffTime) return false;

        const parts = cutoffTime.trim().split(":");
        if (parts.length !== 2) return false;

        const [cutoffHours, cutoffMinutes] = parts.map(Number);
        if (!Number.isFinite(cutoffHours) || !Number.isFinite(cutoffMinutes)) return false;
        console.log("accountGmtValue:" + accountGmtValue);
        const currentMinutes = getTimeByGMT(accountGmtValue);
         if (Number.isNaN(currentMinutes)) return false;
        const cutoffTotalMinutes = cutoffHours * 60 + cutoffMinutes;

        return currentMinutes > cutoffTotalMinutes;
    }
};